import EducationFilter, { EducationFilterResult } from "core/components/filter/components/educationFilter"
import FitlerActionButtonGroup from "core/components/filter/components/filterActionButtonGroup"
import PlaceFilter, { PlaceFilterResult } from "core/components/filter/components/placeFilter"
import { KursusoverviewFilterModel } from "../models/KursusoverviewModel";
import UserFilterPermissions from "core/sharedmodels/userPermissions/userFilterPermissions";
import { useCallback, useState } from "react";
import { hasAnyDefinedProperties } from "index";
import { Dropdown } from "core/components/dropdown/dropdown";
import useEnumDropdownOptions from "core/components/dropdown/hooks/useEnumDropdownOptions";
import { GetLaegekursusGruppeTranslation, LaegekursusGruppeTypeEnum } from "core/sharedmodels/kursus/laegekursusGruppeTypeEnum";
import { Localizer } from "infrastructure/localization/localizer";

type KursusOverviewFilterProps = {
    filter: KursusoverviewFilterModel;
    filterCallback: (filter: KursusoverviewFilterModel) => void;
    closeModal: () => void;
    permissions: UserFilterPermissions
}

export const KursusOverviewFilter = ({
  filter: initialFilter,
  filterCallback,
  closeModal,
  permissions
}: KursusOverviewFilterProps) => {

  const [filter, setFilter] = useState<KursusoverviewFilterModel>(initialFilter);
  const initialFilterApplied = hasAnyDefinedProperties(initialFilter);

  const [laegeKursusGruppeTypeDropdownOptions] = useEnumDropdownOptions<LaegekursusGruppeTypeEnum>(LaegekursusGruppeTypeEnum, GetLaegekursusGruppeTranslation);

  const onPlaceFilterChange = useCallback((result: PlaceFilterResult) => {
    setFilter((prev): KursusoverviewFilterModel => ({
      ...prev, 
      regionIds: result.regioner
    }));
  }, []);

  const onEducationFilterChange = useCallback((result: EducationFilterResult) => {
    setFilter((prev): KursusoverviewFilterModel => (
      {
        ...prev, 
        specialeIds: result.specialer,
        uddannelseIds: result.uddannelser
      }
    ));
  }, []);

  const onKursusGrupperFilterChange = useCallback((kursusGrupper: LaegekursusGruppeTypeEnum[]) => {
    setFilter((prev): KursusoverviewFilterModel => (
      {
        ...prev, 
        kursusgrupper: kursusGrupper
      }
    ));
  }, []);

  const applyFilter = useCallback(() => {
      closeModal();
      filterCallback(filter);
  }, [closeModal, filter, filterCallback]);

  return (
    <div className="row">
      <div className="col-sm-12 flex-container-column">

        <EducationFilter 
          onChange={onEducationFilterChange} 
          permissions={permissions} 
          initialSelectedValues={{
            specialer: filter.specialeIds ?? [],
            uddannelser: filter.uddannelseIds ?? [],
          }}
        />
        
        <PlaceFilter 
          onChange={onPlaceFilterChange} 
          permissions={permissions}
          preselectViaPermissions={!initialFilterApplied}
          visualizationConfig={{
            showRegioner: true
          }}
          initialSelectedValues={{
            regioner: filter.regionIds ?? [],
            omraader: [],
            afdelinger: [],
            praksiser: [],
            sygehuse: [],
            allRegionsSelected: undefined
          }}
        />

        <div className="margin-top-s">
          <label>{Localizer.global_kursusGruppe()}</label>
          <Dropdown
              placeholder={Localizer.kursusoverview_filter_chooseKursusGrupper()}
              options={laegeKursusGruppeTypeDropdownOptions.sortBy(x => x.label)}
              value={laegeKursusGruppeTypeDropdownOptions.filter(x => filter.kursusgrupper?.includes(x.value))}
              onChange={(newVal) => onKursusGrupperFilterChange(newVal.map(x => x.value))}
              isClearable
              isMulti
          />
        </div>
        
        <FitlerActionButtonGroup 
          onClose={closeModal} 
          onApplyFilter={applyFilter}
        />
      </div>
  </div>
  )
}